import React, { Fragment, useEffect, useState, useRef, createContext } from "react";
import { useTranslation } from "react-i18next";
import { TbArrowNarrowRight } from "react-icons/tb";
import { useTheme } from "../../../../components/ThemeSwitcher/ThemeSwitcher";
import MapSearch from "./MapSearch";
import DataSearch from "./DataSearch";
import './Search.css';
import {
    mapsearchQuery, datasearchQuery, zoomToResults,
    getPublicMapservices,
    getUserMapservices
} from "./SearchUtils";
import SearchResult from "./SearchResult";
import { MdKeyboardBackspace, MdKeyboardArrowRight } from "react-icons/md";
import { highlightAndZoomToFeatureUsingLayerView, showAlert, removeAllHighlights } from "../../../../utils/Helpers";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { getLocalStorageItem } from "../../../../utils/HelperFunctions";
import { useNavigate } from "react-router-dom";
import fetchDataWithAuth from "../../../../utils/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DivLoader from "../../../../components/common/Loader/DivLoader";
import { useSelectedSearchContext } from '../../../../components/EDPContext';
import { applyTheme } from "../../../../utils/theme";
import { useUserGroups } from "../../../../components/common/Auth/UserGroupsContext";

export const SearchContext = createContext();
let elementInstances = {};
const SearchComponent = (props) => {
    const { mapview, type, isMobile } = props;
    const { t } = useTranslation();
    const { groupNames, groupFunctions, groupServices } = useUserGroups();
    const searchRef = useRef(null);
    const mapSearchRef = useRef(null);
    const searchResultRef = useRef(null);
    const [loading, showLoading] = useState(true);
    const currentFetchTypeRef = useRef(null);
    const [clipGeometry, setClipGeometry] = useState(null);
    const [showSearch, setShowSearch] = useState(false);
    const { selectedSearchType, setselectedSearchType, isCollapsed, setIsCollapsed, dataSearchRef, searchlayers, setSearchlayers } = useSelectedSearchContext();
    const [searchLayers, setSearchLayers] = useState(searchlayers.length > 0 ? searchlayers : []);
    const [activeSearch, setActiveSearch] = useState(undefined);
    const [searchResult, setSearchResult] = useState(undefined);
    const [showResult, setShowResult] = useState(false);
    const [enableActions, setEnableActions] = useState(false);
    const [enableResultActions, setEnableResultActions] = useState(false);
    const [selectedRFeatures, setSelectedRFeatures] = React.useState([]);
    const [visibleMaplayers, setVisibleMaplayers] = React.useState(null);
    const [selectAllChecked, setSelectAllChecked] = React.useState(false);
    const [selectedResultLayerOption, setSelectedResultLayerOption] = React.useState(undefined);
    const [maplayersLoaded, setMaplayersLoaded] = React.useState(false);
    let { theme } = useTheme();
    const navigate = useNavigate();
    const [isDisplayed, setIsDisplayed] = useState(true);
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipRef = useRef(null);
    const handlesRef = useRef([]);

    const [prevVisibleLayers, setPrevVisibleLayers] = useState([]);
    const [prevSelectedData, setPrevSelectedData] = useState([]);
    // const [isCollapsed, setIsCollapsed] = useState(false);

    const updateTheme = (event) => {
        const newTheme = event.detail;
        theme = newTheme;

    };

    useEffect(() => {
        window.addEventListener("themeChanged", updateTheme);

        return () => {
            window.removeEventListener("themeChanged", updateTheme);
        };
    }, [])
    const toggleDisplay = () => {
        setIsDisplayed((prevState) => {
            if (prevState) {
                closeSearch();
            }
            return !prevState;
        });
    };

    useEffect(() => {
        if (!mapview) return;


        const visibleMaplayers = mapview.map.layers.filter(layer => (layer.type !== "graphics" && layer.visible));
        setVisibleMaplayers(activeSearch === "map" ? visibleMaplayers : [1]);


        if (isMobile) {
            const ls = mapview.map.layers.filter((layer) => (layer.type !== "graphics")).map(layer => layer.loaded);
            layersLoadHandler(ls);
        }

        reactiveUtils.when(
            () => mapview.map.layers.filter((layer) => (layer.type !== "graphics")).map(layer => layer.loaded),
            (loadedStatuses) => {
                layersLoadHandler(loadedStatuses);
            }
        );

        const handlePointerMove = (event) => {
            if (tooltipRef.current) {
                try {
                    const screenPoint = { x: event.native.x, y: event.native.y };

                    if (
                        screenPoint &&
                        screenPoint.x && screenPoint.y &&
                        Number.isFinite(screenPoint.x) && Number.isFinite(screenPoint.y)
                    ) {
                        tooltipRef.current.style.display = 'block';
                        tooltipRef.current.style.left = `${screenPoint.x + 15}px`;
                        tooltipRef.current.style.top = `${screenPoint.y + 15}px`;
                    }
                } catch (error) {
                    console.error('Error converting screen coordinates to map coordinates:', error);
                }
            }
        };

        const handlePointerOut = () => {
            if (tooltipRef.current) {
                tooltipRef.current.style.display = 'none';
            }
        };

        handlesRef.current.push(mapview.on('pointer-move', handlePointerMove));
        handlesRef.current.push(mapview.on('pointer-out', handlePointerOut));


    }, [mapview, showSearch, activeSearch]);

    const layersLoadHandler = (loadedStatuses) => {

        if (loadedStatuses.every(status => status)) {
            setMaplayersLoaded(true);
        } else {
            setMaplayersLoaded(false);
            showLoading(true);
        }
    }
    const fetchData = async () => {
        let layers = [];
        showLoading(true);
        currentFetchTypeRef.current = activeSearch;

        if (activeSearch === 'data') {
            if (isCollapsed) {
                setIsCollapsed(!isCollapsed)
            }
            const userID = getLocalStorageItem("UserId");
            if (userID) {
                var userServicesResult = await getUserMapservices(fetchDataWithAuth, userID, navigate, t);
                if (userServicesResult.error) {
                    showAlert(userServicesResult.error, "error");
                } else {
                    const searchServices = userServicesResult.data;

                    layers.push(...searchServices);
                }
            }

            var publicServicesResult = await getPublicMapservices();
            if (publicServicesResult.error) {
                showAlert(publicServicesResult.error, "error");
            } else {
                const searchServices = publicServicesResult.data;
                layers.push(...searchServices);

            }



        } else {
            if (maplayersLoaded) {

                mapview.map.layers.forEach(layer => {
                    if (layer.type === "graphics") return;  // Skip graphics layers
                    if (layer.visible) {
                        let mapservice = layer;
                        const sublayers = layer.sublayers;

                        if (sublayers && sublayers.length > 0) {
                            // Filter visible sublayers
                            const visibleSublayers = sublayers.filter(sublayer => sublayer.visible);

                            if (visibleSublayers.length > 0) {
                                // Create a new object with the visible sublayers
                                // const updatedLayer = {
                                //     ...mapservice,
                                //     sublayers: visibleSublayers
                                // };

                                const updatedLayer = {
                                    id: mapservice.id,
                                    title: mapservice.title,
                                    url: mapservice.url,
                                    type: mapservice.type,
                                    visible: mapservice.visible,
                                    ...mapservice, // Spread operator to include all other enumerable properties
                                    sublayers: visibleSublayers,
                                };

                                layers.push(updatedLayer);  // Add the layer with visible sublayers to the array
                            }
                        } else {
                            layers.push(mapservice);  // No sublayers, just add the layer
                        }
                    }
                });


            }
        }
        if (currentFetchTypeRef.current !== activeSearch) {
            showLoading(false);
            return;
        }
        setSearchLayers(layers);
        setSearchlayers(layers);
        setVisibleMaplayers(layers)
        showLoading(false);
    };
    useEffect(() => {


        if (activeSearch) {
            fetchData();
        }

        return () => {
            // Your cleanup code here
        };
    }, [maplayersLoaded, activeSearch, mapview, showSearch]);

    const controlSearchWidgetState = (searchType) => {
    if (selectedSearchType !== searchType) {
        setSearchResult(undefined);
        setShowResult(false);
    }

    setselectedSearchType(null);
    setTimeout(() => setselectedSearchType(searchType), 0);

    // Toggle collapse if same type
    const newCollapsed = activeSearch === searchType ? !isCollapsed : false;
    setIsCollapsed(newCollapsed);

    setShowSearch(true);
    (searchLayers.length > 0) ? toggleSidebar(searchType) : setSearchLayers([]);
    setActiveSearch(searchType);

    // Always add class if panel is open
    if (!newCollapsed) {
        document.body.classList.add("searchOpenRightside");
    } else {
        document.body.classList.remove("searchOpenRightside");
    }
};

    const getSelectedLayers = async () => {
        if (mapSearchRef.current) {
            const selectedItems = mapSearchRef.current.getSelectedItems();
            return selectedItems;
        } else {
            return [];
        }
    };

    const resetSearch = () => {
        if (activeSearch) {
            activeSearch === 'map' ? mapSearchRef.current?.reset() : dataSearchRef.current?.reset();
        }
        setSearchResult(undefined);
        removeAllHighlights();
    }

    const submitSearch = async () => {
        showLoading(true);
        setShowTooltip(false);
        try {
            if (activeSearch === 'map') {
                if (mapSearchRef && mapSearchRef.current) {
                    const qselectedLayers = await getSelectedLayers();
                    mapSearchRef?.current?.cancelSketch();
                    setClipGeometry(mapSearchRef?.current?.getQueryOptions().geometry);
                    const searchResults = await mapsearchQuery(qselectedLayers, mapSearchRef.current.getQueryOptions(), mapview);
                    setSearchResult(searchResults);
                }
            } else {
                if (dataSearchRef && dataSearchRef.current) {
                    const isValid = dataSearchRef.current.validateInputs();
                    if (!isValid) {
                        showLoading(false);
                        return;
                    }
                    const queryLayerUrl = dataSearchRef.current.queryLayerUrl;
                    const selectedLayerName = dataSearchRef.current.selectedLayerRef.current.text;
                    setClipGeometry(dataSearchRef?.current?.getQueryOptions()?.geometry);
                    const searchResults = await datasearchQuery(queryLayerUrl, dataSearchRef.current.getQueryOptions(), t);
                    if (searchResults) {
                        setSearchResult(searchResults);
                        setSelectedResultLayerOption(selectedLayerName);
                    } else {
                        //showAlert(t("queryFailed"), "error");
                        showLoading(false);
                    }
                } else {
                    showLoading(false);
                }
            }
        } catch (error) {
            showAlert(t('queryFailed'), "error");
        } finally {
            showLoading(false);
        }

    }

    const clearSelectedResults = () => {
        searchResultRef?.current?.clearSearchResultSelection();
        setSelectAllChecked(false);
    }

    useEffect(() => {
        if (searchResult && searchResult.length > 0) {
            setShowResult(true);
        }
    }, [searchResult]);

    const closeSearch = () => {
        resetSearch();
        setShowSearch(!showSearch);
        setActiveSearch(undefined);
        setShowResult(false);
        setSearchResult(undefined);
        setselectedSearchType(null);
        removeAllHighlights();
        document.body.classList.remove("searchOpenRightside");
    }

    const toggleView = () => {
        mapSearchRef?.current?.setActiveTool(undefined);
        setShowResult(!showResult);
    }

    const toggleResultActions = (visible) => {
        setEnableResultActions(visible);
    }

    useEffect(() => {
        if (isMobile) {
            controlSearchWidgetState(type[0]);
        }
    }, [isMobile, type]);

    // const toggleSidebar = (searchType) => {
    //     const visibleMaplayers = mapview.map.layers.filter(layer => (layer.type !== "graphics" && layer.visible));
    //     setVisibleMaplayers(activeSearch === "map" ? visibleMaplayers : [1]);

    //     if (!isCollapsed) {
    //         // Store current selections before collapsing
    //         setPrevVisibleLayers(mapview.map.layers.filter(layer => layer.type !== "graphics" && layer.visible));
    //         setPrevSelectedData(searchLayers); // Store selected data
    //         setSearchLayers([]); // Reset data
    //         // setSearchlayers([]); // Reset data
    //         //mapview.map.layers.forEach(layer => layer.visible = false); // Hide all layers
    //     } else {
    //         // Restore previous selections when expanding
    //         prevVisibleLayers.forEach(layer => layer.visible = true);
    //         if ((prevSelectedData.length === 0 && visibleMaplayers.length > 0) || (visibleMaplayers.length !== prevSelectedData.length)) {
    //             submitSearch()
    //         }
    //         else {
    //             setSearchLayers(prevSelectedData);
    //             setSearchlayers(prevSelectedData);
    //         }


    //     }
    //     if (activeSearch === searchType || searchType?.type == "click") {
    //         setIsCollapsed(!isCollapsed);
    //     }
    //     else {
    //         // If panel types don't match, force expanded state
    //         setIsCollapsed(false);
    //     }


    // };

    const toggleSidebar = (searchType) => {
    const visibleMaplayers = mapview.map.layers.filter(layer => layer.type !== "graphics" && layer.visible);
    setVisibleMaplayers(activeSearch === "map" ? visibleMaplayers : [1]);

    if (!isCollapsed) {
        // Store current selections before collapsing
        setPrevVisibleLayers(mapview.map.layers.filter(layer => layer.type !== "graphics" && layer.visible));
        setPrevSelectedData(searchLayers);
        setSearchLayers([]);
    } else {
        // Restore previous selections when expanding
        prevVisibleLayers.forEach(layer => layer.visible = true);
        if ((prevSelectedData.length === 0 && visibleMaplayers.length > 0) || (visibleMaplayers.length !== prevSelectedData.length)) {
            submitSearch();
        } else {
            setSearchLayers(prevSelectedData);
            setSearchlayers(prevSelectedData);
        }
    }

    // Compute new collapsed state
    const newCollapsed = (activeSearch === searchType || searchType?.type === "click") ? !isCollapsed : false;
    setIsCollapsed(newCollapsed);

    // Update body class based on new state
    if (newCollapsed) {
        document.body.classList.remove("searchOpenRightside");
    } else {
        document.body.classList.add("searchOpenRightside");
    }
};

    useEffect(() => {
        const closeHandler = () => {
            closeSearch();
        };

        window.addEventListener("closeAllSearchWidgets", closeHandler);

        return () => window.removeEventListener("closeAllSearchWidgets", closeHandler);
        }, []);


    //For toggleing the mapsearch or datasearch
    // useEffect(() => {
    //     if (isCollapsed) {
    //         setIsCollapsed(isCollapsed);
    //     }
    // }, [isCollapsed])
    // useEffect(() => {
    //     document.body.classList.add('searchOpenRightSide');
    //     return () => {
    //         document.body.classList.remove('searchOpenRightSide');
    //     };
    // })

    return (
        <SearchContext.Provider value={
            {
                showLoading, toggleResultActions, mapview, selectedRFeatures, setSelectedRFeatures,
                setEnableActions, selectAllChecked, setSelectAllChecked, activeSearch,
                selectedResultLayerOption, setSelectedResultLayerOption, setShowTooltip, tooltipRef, showTooltip
            }
        }>
            <div id='search' className="arcgis-search-component controller-wrapper">
                {showTooltip && <div className="tooltip-container" ref={tooltipRef}> {t('clickOnMapToStartDrawing')}</div>}
                <div className="searchDiv mobSearchIcon-none">
                    <div className="search-box ">
                        <div className="justify-content-between align-items-center Buts" style={{ display: isDisplayed ? 'flex' : 'none' }}>
                            <a className="arrorSearchRightSvg" onClick={toggleDisplay}>
                                {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="closesearch" alt="Close">
                                    <path d="M10.0589 8.99892L13.2839 5.78142C13.4251 5.64019 13.5045 5.44864 13.5045 5.24892C13.5045 5.04919 13.4251 4.85765 13.2839 4.71642C13.1427 4.57519 12.9511 4.49585 12.7514 4.49585C12.5517 4.49585 12.3601 4.57519 12.2189 4.71642L9.00142 7.94142L5.78392 4.71642C5.64269 4.57519 5.45115 4.49585 5.25142 4.49585C5.05169 4.49585 4.86015 4.57519 4.71892 4.71642C4.57769 4.85765 4.49835 5.04919 4.49835 5.24892C4.49835 5.44864 4.57769 5.64019 4.71892 5.78142L7.94392 8.99892L4.71892 12.2164C4.64862 12.2861 4.59283 12.3691 4.55475 12.4605C4.51667 12.5519 4.49707 12.6499 4.49707 12.7489C4.49707 12.8479 4.51667 12.946 4.55475 13.0373C4.59283 13.1287 4.64862 13.2117 4.71892 13.2814C4.78864 13.3517 4.87159 13.4075 4.96299 13.4456C5.05438 13.4837 5.15241 13.5033 5.25142 13.5033C5.35043 13.5033 5.44846 13.4837 5.53985 13.4456C5.63125 13.4075 5.7142 13.3517 5.78392 13.2814L9.00142 10.0564L12.2189 13.2814C12.2886 13.3517 12.3716 13.4075 12.463 13.4456C12.5544 13.4837 12.6524 13.5033 12.7514 13.5033C12.8504 13.5033 12.9485 13.4837 13.0399 13.4456C13.1312 13.4075 13.2142 13.3517 13.2839 13.2814C13.3542 13.2117 13.41 13.1287 13.4481 13.0373C13.4862 12.946 13.5058 12.8479 13.5058 12.7489C13.5058 12.6499 13.4862 12.5519 13.4481 12.4605C13.41 12.3691 13.3542 12.2861 13.2839 12.2164L10.0589 8.99892Z" fill="white" fillOpacity="0.6" />
                                </svg> */}
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="closesearch" alt="Arrow Right">
                                    <path d="M6 4L12 9L6 14" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                            {groupFunctions.includes(window.userFunctions.spatialSearch) && (
                                <a className={activeSearch === 'map' ? 'active' : ''} onClick={() => controlSearchWidgetState('map')} style={{ fontSize: '0.8rem' }}>
                                    <svg width="15" height="15" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_3066_150057)">
                                            <path d="M11.0563 0.658385C10.6507 0.4752 10.187 0.4752 9.78129 0.658385L5.93914 2.39328C5.80604 2.45338 5.65471 2.45338 5.52161 2.39328L2.72133 1.12884C1.67568 0.656679 0.520996 1.43971 0.520996 2.5709V6.51178C0.520996 6.79949 0.754228 7.03271 1.04193 7.03271C1.32964 7.03271 1.56287 6.79949 1.56287 6.51178V2.5709C1.56287 2.17008 1.96027 1.92835 2.29257 2.0784L5.09285 3.34284C5.13122 3.36016 5.17013 3.37586 5.20943 3.3899V12.8375L1.87505 11.3319C1.68861 11.2476 1.56287 11.0564 1.56287 10.8393V9.11646C1.56287 8.82875 1.32964 8.59553 1.04193 8.59553C0.754228 8.59553 0.520996 8.82875 0.520996 9.11646V10.8393C0.520996 11.4589 0.880222 12.0258 1.44628 12.2814L5.09285 13.928C5.49853 14.1112 5.96221 14.1112 6.36789 13.928L7.55938 13.39C7.44134 13.0607 7.3601 12.714 7.32064 12.3546L6.25131 12.8375V3.3899C6.29061 3.37586 6.32953 3.36016 6.36789 3.34284L9.90352 1.74635C9.8998 1.77147 9.89787 1.79718 9.89787 1.82334V7.73184C10.2255 7.57618 10.5747 7.45845 10.9397 7.38437V1.82334C10.9397 1.79718 10.9378 1.77147 10.9341 1.74635L14.2741 3.25451C14.4606 3.33872 14.5863 3.52993 14.5863 3.74703V8.20448C14.9912 8.50861 15.3438 8.87858 15.6282 9.2985V3.74703C15.6282 3.12748 15.2689 2.56056 14.7029 2.30496L11.0563 0.658385Z" fill="#ffffff" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M9.38048 9.3806C10.7745 7.98658 13.0346 7.98658 14.4287 9.3806C15.6975 10.6495 15.8114 12.636 14.7703 14.0337L15.9964 15.2599C16.1999 15.4633 16.1999 15.7931 15.9964 15.9966C15.793 16.2 15.4632 16.2 15.2597 15.9966L14.0336 14.7704C12.6359 15.8116 10.6494 15.6976 9.38048 14.4288C7.98645 13.0347 7.98645 10.7746 9.38048 9.3806ZM13.6919 10.1173C12.7048 9.13016 11.1043 9.13016 10.1172 10.1173C9.13004 11.1044 9.13004 12.7049 10.1172 13.692C11.1043 14.6792 12.7048 14.6792 13.6919 13.692C14.6791 12.7049 14.6791 11.1044 13.6919 10.1173Z" fill="#ffffff" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_3066_150057">
                                                <rect width="16.67" height="16.67" fill="#ffffff" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {t('MapSearch')}
                                </a>
                            )}
                            <span></span>
                            {groupFunctions.includes(window.userFunctions.dataSearch) && (
                                <a className={activeSearch === 'data' ? 'active' : ''} onClick={() => controlSearchWidgetState('data')} style={{ fontSize: '0.8rem' }}>


                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_3066_150069)">
                                            <path d="M0.261858 12.9894C0.261858 12.9894 0.261858 12.9922 0.261858 12.9938C0.410608 14.1563 1.48467 15.1972 2.65623 15.3125H2.6603C4.42905 15.4747 6.22592 15.5569 8.0003 15.5569C9.77467 15.5569 11.5719 15.4747 13.3406 15.3125H13.3444C14.5165 15.1972 15.5906 14.1563 15.7387 12.9938C15.7387 12.9922 15.7387 12.991 15.7387 12.9894C15.9312 11.3875 16.0122 10.0657 15.995 8.65253C16.0087 7.39253 15.9909 6.05691 15.939 5.15691C15.8662 3.96503 14.794 2.93472 13.5494 2.85972H13.5459C11.6256 2.75472 9.66655 2.70347 7.72405 2.70941C7.71387 2.70951 7.70379 2.70734 7.69455 2.70307C7.68531 2.6988 7.67713 2.69254 7.67061 2.68472C7.14842 2.07535 6.68498 1.52316 6.25373 0.997221C6.10474 0.813201 5.91418 0.667186 5.69773 0.571188C5.48129 0.47519 5.24515 0.431953 5.00873 0.445033C4.2278 0.484408 3.43748 0.540971 2.65623 0.612533H2.6528C1.48123 0.728158 0.406233 1.76878 0.259358 2.93222V2.9366C0.0706082 4.51097 -0.0209543 6.80878 0.00404567 8.86941C-0.00282933 10.2016 0.0793582 11.4688 0.261858 12.9894ZM14.5625 12.846C14.4831 13.4572 13.85 14.0691 13.2319 14.131C11.4997 14.2897 9.73998 14.3703 8.00217 14.3703C6.26436 14.3703 4.50498 14.2897 2.7728 14.131C2.15467 14.0685 1.52123 13.4572 1.44217 12.846C1.18748 10.735 1.13373 9.12972 1.24998 7.12285C1.2853 6.53128 1.8803 5.97847 2.52311 5.93753C4.32342 5.83941 6.16623 5.78941 8.00061 5.78941C9.83498 5.78941 11.6781 5.84066 13.4784 5.93753C14.1212 5.97722 14.7162 6.53128 14.7525 7.11941C14.8678 9.12972 14.814 10.735 14.5625 12.846ZM2.76842 1.79472C3.53061 1.72472 4.30467 1.66972 5.06967 1.63035C5.12031 1.62706 5.17098 1.63616 5.21732 1.65685C5.26365 1.67754 5.30425 1.7092 5.33561 1.7491C5.77311 2.28222 6.24186 2.84097 6.76905 3.45722C6.88713 3.59515 7.0337 3.70585 7.19868 3.7817C7.36365 3.85756 7.5431 3.89675 7.72467 3.8966H7.72748C9.64748 3.89097 11.5825 3.9416 13.4797 4.04503C14.0919 4.08253 14.6606 4.58566 14.7453 5.14253C14.3849 4.91501 13.9734 4.78126 13.5481 4.75347H13.545C11.7225 4.65378 9.85748 4.60347 8.00061 4.60347C6.14373 4.60347 4.27905 4.65378 2.45655 4.75347H2.45311C2.03327 4.7808 1.62672 4.91156 1.26967 5.1341C1.31248 4.37503 1.36717 3.66816 1.43748 3.07972C1.51623 2.46878 2.14967 1.8566 2.76842 1.79472Z" fill="#ffffff" />
                                            <path d="M11.2769 12.3029C10.9816 11.9613 10.6191 11.7107 10.2682 11.4685C10.0932 11.3476 9.91287 11.2232 9.74474 11.0892C10.1057 10.5107 10.2413 9.8196 10.1256 9.14761C10.0099 8.47562 9.65107 7.86966 9.11744 7.44517C8.58382 7.02068 7.91269 6.80731 7.2319 6.84572C6.55111 6.88413 5.90823 7.17162 5.42574 7.65344C4.94324 8.13526 4.65484 8.77773 4.61548 9.45846C4.57611 10.1392 4.78853 10.8106 5.21227 11.3449C5.63601 11.8791 6.24146 12.2388 6.91329 12.3554C7.58511 12.472 8.27637 12.3374 8.85537 11.9773C8.98974 12.1454 9.11412 12.3254 9.23537 12.5007C9.47755 12.8513 9.72818 13.2135 10.0704 13.5085L10.0897 13.5229C10.1985 13.5893 10.3236 13.6239 10.451 13.6229C10.6439 13.6223 10.8298 13.5501 10.9726 13.4204L11.1835 13.2098L11.1885 13.2048C11.4132 12.9585 11.4563 12.5876 11.291 12.3223L11.2769 12.3029ZM8.97787 9.62009C8.97787 10.0415 8.81048 10.4456 8.51253 10.7435C8.21458 11.0415 7.81048 11.2088 7.38912 11.2088H7.38724C7.0731 11.2085 6.76611 11.115 6.50509 10.9402C6.24407 10.7654 6.04073 10.5171 5.92076 10.2268C5.8008 9.93644 5.76961 9.61705 5.83112 9.30899C5.89264 9.00093 6.0441 8.71801 6.26636 8.49601C6.48863 8.27401 6.77172 8.12288 7.07985 8.06173C7.38799 8.00058 7.70734 8.03215 7.99754 8.15245C8.28773 8.27276 8.53575 8.47639 8.71024 8.73762C8.88473 8.99885 8.97787 9.30594 8.97787 9.62009Z" fill="#ffffff" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_3066_150069">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {t('DataSearch')}
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="search-btn" onClick={toggleDisplay}>
                        <FontAwesomeIcon icon={faSearch} />
                    </div>
                </div>
                {type && type.length > 0 && (
                    <Fragment>

                        {showSearch && activeSearch && (
                            <>
                                <div className={`SideBar MDSearchSidebar ${isMobile ? 'mobile' : 'open'} ${isCollapsed ? 'collapsed' : ''}`} ref={searchRef}>

                                    {!isMobile && <div className=" Header">
                                        <h3 className="panelHeading --zoomout">{activeSearch === 'map' ? t('MapSearch') : t('DataSearch')}</h3>
                                        <button className="panelcross" onClick={closeSearch}><img src={`${process.env.PUBLIC_URL}/images/close.svg`} alt={t('close')} /></button>
                                    </div>}
                                    <MdKeyboardArrowRight onClick={toggleSidebar} className="slidearrow-icon" />

                                    <div className="content-wrapper">
                                        {visibleMaplayers && (
                                            visibleMaplayers.length > 0 ? (
                                                // searchLayers.length > 0 &&
                                                <div className="content">

                                                    <div className={`search-options d-flex flex-column justify-content-between h-100 ${showResult ? 'hide' : ''}`}>
                                                        {activeSearch === 'map' && <MapSearch layers={searchlayers.length > 0 ? searchlayers : searchLayers} ref={mapSearchRef} />}
                                                        {activeSearch === 'data' && <DataSearch data={searchlayers.length > 0 ? searchlayers : searchLayers} ref={dataSearchRef} />}

                                                        <div className={`d-flex gap-2 mb-2 align-items-center panelfooter abs searchMap-pos-left ${activeSearch === 'data' ? 'dataMobtop' : ''}`}>

                                                            {searchResult && searchResult.length > 0 && (
                                                                <div className="next to-result" onClick={toggleView} style={{ cursor: 'pointer' }}>
                                                                    <span className="label">{t('results')}</span>
                                                                    <TbArrowNarrowRight />
                                                                </div>
                                                            )}


                                                            <button
                                                                className="btn btn-outline"
                                                                onClick={resetSearch}
                                                            >
                                                                {t('reset')}
                                                            </button>
                                                            <button
                                                                className={`btn btn-primary ${enableActions ? '' : 'disabled'}`}
                                                                onClick={enableActions ? submitSearch : null}
                                                            >
                                                                {t('Search')}
                                                            </button>

                                                        </div>
                                                    </div>
                                                    <div className={`search-results scrll-mapSearch-Item d-flex flex-column justify-content-between h-100 ${showResult ? '' : 'hide'}`}>
                                                        {searchResult && <SearchResult items={searchResult} ref={searchResultRef} clipgeometry={clipGeometry} mapSearchRef={activeSearch === "map" ? mapSearchRef : dataSearchRef} activeSearch={activeSearch} />}

                                                        <div className="d-flex gap-2 searchMap-pos-left mb-2 panelfooter align-items-center abs">

                                                            <div className="DefaultLink" onClick={toggleView} style={{ cursor: 'pointer' }}>
                                                                <MdKeyboardBackspace className="arabic-rotate-arrow" />
                                                                {t('back')}
                                                            </div>

                                                            <button className="action clear btn btn-outline" onClick={clearSelectedResults}>{t('Clear')}</button>

                                                            <button
                                                                className={`action highlight btn btn-outline ${enableResultActions ? '' : 'disabled'}`}
                                                                onClick={enableResultActions ? () => highlightAndZoomToFeatureUsingLayerView(selectedRFeatures, mapview) : null}>
                                                                {t('highlight')}
                                                            </button>
                                                            <button
                                                                className={`action zoom btn btn-outline  ${enableResultActions ? '' : 'disabled'}`}
                                                                onClick={enableResultActions ? () => zoomToResults(selectedRFeatures, mapview) : null}>
                                                                {t('zoom')}
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="nolayers d-flex flex-column justify-content-center text-center h-100 align-items-center">
                                                    <img alt="" src={`${process.env.PUBLIC_URL}/images/image-placeholder.svg`} className="mb-2" />
                                                    {t('addAtleastOneLayerToMap')}
                                                </div>
                                            )
                                        )}
                                    </div>
                                    {loading && <DivLoader />}
                                </div>


                                {isCollapsed && (
                                    <div className="col-sm-12 rightSide-Icon-Widget searchRightPnlHd">
                                        <button className="icon-panel" onClick={toggleSidebar}>
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/${activeSearch === 'map' ? 'mapsearchmob' : 'datasearchmob'}.svg`}
                                                alt={activeSearch === 'map' ? 'Map Search Icon' : 'Data Search Icon'}
                                            />
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </Fragment>
                )}
            </div>
        </SearchContext.Provider>
    );
};

export default SearchComponent;


